import { activeSiteConfig } from "@config/site/site-config";

export const getMoneyFromCentsAndFractions = (cents = 0, fractions = 0) => {
    if (!cents) return 0;

    return cents / Math.pow(10, fractions);
};

export const roundPrice = (price: number, method: "floor" | "ceil") => {
    const roundingUnit = activeSiteConfig.roundingUnit;
    if (!roundingUnit) {
        return price;
    }

    const scaledRoundingUnit = roundingUnit * 100;
    return method === "floor"
        ? Math.floor(price / scaledRoundingUnit) * scaledRoundingUnit
        : Math.ceil(price / scaledRoundingUnit) * scaledRoundingUnit;
};
